if(!customElements.get('image-hotspots')) {
    customElements.define('image-hotspots', class ImageHotspots extends HTMLElement {
        constructor() {
            super();

            // Imposta tutti i punti come chiusi all'inizio
            this.querySelectorAll('.spot').forEach(spot => {
                spot.setAttribute('aria-expanded', 'false');
            });

            // Imposta tutte le card prodotto come nascoste e blocca la propagazione del click
            this.querySelectorAll('.spot-product').forEach((productCard) => {
                productCard.setAttribute('aria-hidden', 'true');
                productCard.addEventListener('click', event => event.stopPropagation());
            });

            this.addEventListener('click', (event)=>{
                if(event.target.classList.contains('spot')) {
                    this.onSpotClick(event.target);
                } else if(!isMobileScreen()) {
                    this.closeAllActive();
                }
            });

            // Ascolta il tasto Esc per chiudere le card attive
            this.addEventListener('keydown', (event)=> {
                if(event.code && event.code.toUpperCase() === 'ESCAPE') {
                    this.closeAllActive();
                }
            });
        }

        /**
         * Gestisce il click su un punto
         * @param {HTMLElement} spot
         */
        onSpotClick(spot) {
            this.activeSpot = spot; // Salva il punto attivo corrente
            this.closeAllActive();

            const hasOpen = spot.getAttribute('aria-expanded') === 'true';
            if(!hasOpen) {
                spot.setAttribute('aria-expanded', 'true');
                const productCard = document.getElementById(spot.getAttribute('data-target'));
                if(!productCard) return;

                productCard.removeAttribute('aria-hidden');
                trapFocus(productCard);
            }
        }

        /**
         * Chiude tutti i punti attivi
         */
        closeAllActive() {
            this.querySelectorAll('.spot[aria-expanded=true]').forEach(spot=>{
                spot.setAttribute('aria-expanded', 'false');
                document.getElementById(spot.getAttribute('data-target'))?.setAttribute('aria-hidden', 'true');
            });

            // Rimuove il trap focus se presente
            if(this.activeSpot) removeTrapFocus(this.activeSpot);
        }
    });
}
